// PAPERLIKE FORK — Rebuy references stripped from gift-add handler (PATCH-DOC §6)

// PAPERLIKE-CUSTOMIZED native asset (vs vanilla Impact / theme default).
// Changes (see theme-changes/PATCH-DOC.md §6):
// - Rebuy references stripped from the gift-add success handler in handleGift() (they would throw a
//   ReferenceError once Rebuy Smart Cart is removed).
// - handleCartAttributes() cart-update URL fixed (2026-07-10): themeVariables.routes never existed, so the
//   _utmCampaign cart attribute (Autocart gift trigger) was never set by the theme — now uses Shopify.routes.root.
// - waitForConsent() removed (2026-10-22b): init() runs 2s after connect for everyone. The gate waited for the
//   _pandectes_gdpr cookie, which non-EU visitors (no banner) never get, so the offer/AutoCart never fired for them.
// - click-outside close (2026-10-22c): clicks on the Pandectes cookie banner no longer close the popup.
if (!window.customElements.get('utm-campaign-popup')) {
  class UtmCampaignPopup extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.utmCampaignParameter = this.dataset.campaignParameter;
      this.delay = parseInt(this.dataset.popupDelay);
      this.locale = this.dataset.locale;
      this.triggerPages = this.dataset.triggerPages ? JSON.parse(this.dataset.triggerPages) : [];
      // PAPERLIKE PATCH 2026-10-22b: no consent gate any more (it never opened for non-EU visitors, who get no
      // Pandectes banner). Short delay so the popup does not land on top of a freshly rendered cookie banner.
      setTimeout(() => this.init(), 2000);
    }

    init() {
      const params = new URLSearchParams(window.location.search);
      const utmCampaign = params.get('offer');
      const currentPath = window.location.pathname;

      const matchesOffer = utmCampaign && utmCampaign === this.utmCampaignParameter;
      const matchesPage = this.triggerPages.some(page => currentPath === page || currentPath === page.replace(/\/$/, ''));

      if (!matchesOffer && !matchesPage) return;

      const storageKey = `utmCampaign:${this.utmCampaignParameter}_locale=${this.locale}`;
      const storedValue = localStorage.getItem(storageKey);
      const parsedTimestamp = parseInt(storedValue);
      const isValidTimestamp = storedValue && !isNaN(parsedTimestamp);
      const isExpired = isValidTimestamp && (Date.now() - parsedTimestamp) > 30 * 24 * 60 * 60 * 1000;

      if (!storedValue || !isValidTimestamp || isExpired) {
        setTimeout(() => {
          this.toggleVisibility(true);
          localStorage.setItem(storageKey, Date.now().toString());
        }, this.delay);
        console.log('not seen campaign');
        this.handleGift();
      }

      this.closeButton = this.querySelector('.popup-modal__close');
      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => this.toggleVisibility(false));
      }

      // PAPERLIKE PATCH 2026-10-22c: clicks on the Pandectes cookie banner/preferences don't count as "outside"
      // (accepting the banner used to close the offer popup). The banner lives in the shadow root of
      // <pandectes-cmp>, so document listeners see that host as the target. A target that is no longer in the
      // DOM (banner removed itself during the click) is ignored for the same reason.
      const isCookieBannerClick = (target) =>
        !target.isConnected || !!target.closest('pandectes-cmp, [id^="pandectes"], [class*="pandectes"], .cc-window');

      document.addEventListener('click', (event) => {
        if (!this.contains(event.target) && !isCookieBannerClick(event.target)) {
          this.toggleVisibility(false);
        }
      });
    }

    async handleGift() {
      this.variantId = this.dataset.giftVariantId;
      if (!this.variantId) {
        this.handleCartAttributes();
      } else {
        let formData = {
          items: [
            {
              id: this.variantId,
              quantity: 1,
              properties : {
                _utmCampaign: this.utmCampaignParameter
              }
            }
          ]
        };

        fetch(`${Shopify.routes.root}cart/add.js`, {
          body: JSON.stringify(formData),
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
        .then((response) => response.json())
        .then((cartResponse) => {
          // Silent gift add: this raw fetch does NOT dispatch the theme's cart:change/variant:add
          // events, so the native Impact cart drawer will NOT auto-open here. We only refresh the
          // header cart count. (Previously this block also set Rebuy.SmartCart.skip_open — removed
          // with the Rebuy removal; that reference would now throw a ReferenceError.)
          const cartCount = document.querySelector('cart-count');
          if(cartCount) {
            fetch(`${Shopify.routes.root}cart.js`)
              .then((response) => response.json())
              .then((cart) => {
                console.log('setting item count from UTM popup: ', cart.item_count)
                cartCount.itemCount = cart.item_count;
              });
          }
        });
      }
    }

    handleCartAttributes() {
      const payload = {
        attributes: {
          "_utmCampaign": this.utmCampaignParameter
        }
      };

      console.log(payload)

      // PAPERLIKE FIX (2026-07-10): was `${themeVariables.routes.cartUpdateUrl}.js` — themeVariables has no
      // `routes` key in Impact 7.x, so this ALWAYS threw and the attribute was never set by the theme (live
      // included; there it was masked by an app capturing utm_campaign). Same pattern as the add.js call above.
      fetch(`${Shopify.routes.root}cart/update.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      })
      .catch(error => {
        console.error('Error adding attributes to cart:', error);
      });
    }

    toggleVisibility(show) {
      this.classList.toggle('active', show);
    }
  }

  window.customElements.define('utm-campaign-popup', UtmCampaignPopup);
}
